(function () {
    'use strict';

    angular
        .module('innovasalud', [
            'angular-google-analytics',
            'mega-menu',
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngMessages',
            'ngSanitize',
            'ngTouch',
            'smoothScroll',
            'toastr',
            'ui.router',
            'ui.bootstrap'
        ]);

})();

(function () {
    'use strict';

    angular
        .module('innovasalud')
        .component('vegasHeader', {
            templateUrl: 'app/components/vegas-header/vegas-header.component.html'            
        });
   

})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .component('tratamientos', {
            templateUrl: 'app/components/tratamientos/tratamientos.seo.html',
            controller: TratamientosComponentController,
            bindings: {
                mainTreatments: '<',
                onTreatmentAdd: '&'
            }
        });


    /** @ngInject */
    function TratamientosComponentController() {

        var vm = this;

        vm.treatments = [];
        vm.addTreatment = addTreatment;


        activate();

        function activate() {            
        }

        /**
         * 
         * @param {string} treatment Tratamiento para agregar a array de consulta
         */
        function addTreatment(treatment) {
            vm.treatments.push(treatment)                        
            vm.onTreatmentAdd({ $event: { treatment : treatment }});
        }


    }




})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .directive('owlJumbo', owlJumbo);

    /** @ngInject */
    function owlJumbo($timeout) {
        var directive = {
            restrict: 'E',
            transclude: false,
            templateUrl: 'app/components/owljumbo/owljumbo.html',
            controller: OwlJumboController,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                customOptions: '='
            },
            link: function (scope, element) {

                var customOptions = scope.customOptions;

                var defaultOptions = {
                    items: 1,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    autoplayHoverPause: false,
                    //animateOut: 'fadeOut',
                    loop: true
                };

                
                for (var key in customOptions) {
                    defaultOptions[key] = customOptions[key];
                }

                $timeout(function () {
                    angular.element('#jumbo-owl').owlCarousel(defaultOptions);
                });
            }
        };

        return directive;
    }

    /** @ngInject */
    function OwlJumboController() {

        var vm = this;

        vm.ngok = 'Directiva Ok';

    }

})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .directive('testimonios', owlTestimonios);

    /** @ngInject */
    function owlTestimonios($timeout) {
        var directive = {
            restrict: 'E',
            transclude: false,
            templateUrl: 'app/components/testimonios/testimonios.seo.html',
            controller: OwlTestimoniosController,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                customOptions: '='
            },
            link: function (scope, element) {

                var customOptions = scope.customOptions;

                var defaultOptions = {
                    items: 2,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    autoplayHoverPause: true,
                    loop: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false
                        },
                        600: {
                            items: 1,
                            nav: false
                        },
                        1000: {
                            items: 2,
                            nav: false                           
                        }
                    }
                };

                
                for (var key in customOptions) {
                    defaultOptions[key] = customOptions[key];
                }

                $timeout(function () {
                    angular.element('#owl-testimonios').owlCarousel(defaultOptions);
                });
            }
        };

        return directive;
    }

    /** @ngInject */
    function OwlTestimoniosController() {

        var vm = this;

    }

})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .component('navbarTratamientos', {
            templateUrl: 'app/components/navbar/navbar.tratamientos.html',
            controller: NavbarTratamientosController            
        });

    /** @ngInject */
    function NavbarTratamientosController() {        
    }

})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .component('innovaNavbar', {
            templateUrl: 'app/components/navbar/navbar.component.html',
            controller: NavbarComponentController,
            bindings: {
                treatmentsCount: '<'
            }
        });


    /** @ngInject */
    function NavbarComponentController() {
    }




})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .component('inboxHelper', {
            templateUrl: 'app/components/inbox/inbox.component.html',
            controller: InboxComponentController,
            bindings: {
                treatments: '<'
            }
        });

    /** @ngInject */
    function InboxComponentController() {

        var vm = this;

        vm.tooltipText = 'Ir al formulario';
    }

})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .component('innovaFooter', {
            templateUrl: 'app/components/footer/footer.component.html',
            controller: FooterComponentController
        });


    /** @ngInject */
    function FooterComponentController($window) {

        var vm = this;


        vm.openMaps = openMaps;

        /**
         * Checks users platform
         * @param {string} platform
         */
        function checkPlatform(platform) {
            return navigator.platform.indexOf(platform);
        }

        function openMaps() {

            var mapUrlHttp = "https://www.google.cl/maps/place/INNOVA+SALUD+Centro+M%C3%A9dico+Integral/@-33.0161304,-71.5531926,17z/data=!3m1!4b1!4m5!3m4!1s0x9689dde7065d5eb9:0xcdc366a2ad7c87b9!8m2!3d-33.0161304!4d-71.5510039";
            var mapUrlMaps = "https://www.google.cl/maps/place/INNOVA+SALUD+Centro+M%C3%A9dico+Integral/@-33.0161304,-71.5531926,17z/data=!3m1!4b1!4m5!3m4!1s0x9689dde7065d5eb9:0xcdc366a2ad7c87b9!8m2!3d-33.0161304!4d-71.5510039"

            if (checkPlatform('iPhone') != -1 || checkPlatform('iPod') != -1 || checkPlatform('iPad') != -1) {
                $window.open(mapUrlMaps, '_blank');
            }
            else {
                $window.open(mapUrlHttp, '_blank');
            }
        }

        

    }




})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .component('equipoMedico', {
            templateUrl: 'app/components/equipo/equipo.seo.html'            
        });    

})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .component('consultaSeparador', {
            templateUrl: 'app/components/consultaseparador/consultaseparador.seo.html'
        });

})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .component('contacto', {
            templateUrl: 'app/components/contacto/contacto.seo.html',
            controller: ContactoComponentController,
            bindings: {
                treatments: '<',
                onTreatmentRemove: '&'
            }
        });

    /** @ngInject */
    function ContactoComponentController($http, $log, $scope, toastr, smoothScroll) {

        var vm = this;

        vm.message = {
            name: '',
            email: '',
            phone: '',
            message: 'Quisiera recibir información respecto a los tratamientos que seleccioné. Muchísimas gracias!'
        }

        vm.removeTreatment = removeTreatment;
        vm.submit = submit;
        vm.test = test;
        /*----------------------------------------------------------------------------------------------------------------*/

        function prepareMessageObject() {
            vm.message.treatments = vm.treatments;
        }

        function removeTreatment(index) {
            vm.onTreatmentRemove({ $item: { index: index } });

        }

        function resetForm() {

            vm.message = {
                name: '',
                email: '',
                phone: '',
                message: 'Quisiera recibir información respecto a los tratamientos que seleccioné. Muchísimas gracias!'
            }

            $scope.contactForm.$setUntouched(); //reinicia validaciones
        }

        function submit() {
            
            prepareMessageObject();

            $http({
                method: 'POST',
                url: 'app/sendmail/sendmail.php',
                data: angular.toJson(vm.message)
            }).then(function successCallback(response) {
                var msg = response;
                $log.info("Envio de correo exitoso." + msg);
                toastr['success']('Mensaje enviado');
                resetForm();                
            }, function errorCallback(response) {
                var msg = response;
                $log.warn("Envio de formulario de contacto a PHP fallo" + msg);
            });
        }

        function test() {
            var element = document.getElementById('equipo-component');

            var options = {                
                offset: 80                
            }

            smoothScroll(element, options);
        }



    }

})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .component('tratamientosClasicos', {
            templateUrl: 'app/components/clasicos/clasicos.seo.html',
            controller: TratamientosClasicosComponentController,
            bindings: {
                mainTreatments: '=',
                onTreatmentAdd: '&'
            }
        });

    /** @ngInject */
    function TratamientosClasicosComponentController() {

        var vm = this;

        vm.treatments = [];
        vm.addTreatment = addTreatment;

        /**
         * 
         * @param {string} treatment Tratamiento para agregar a array de consulta
         */
        function addTreatment(treatment) {
            vm.treatments.push(treatment)
            vm.onTreatmentAdd({ $event: { treatment: treatment } });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('innovasalud')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController(toastr) {
        var vm = this;

        vm.addTreatment = addTreatment;
        vm.showToastr = showToastr;
        vm.treatmentsContact = [];


        // ----------------------------------------------------------------------------------------------------------- //

        activate();

        function activate() {

        }

        // ----------------------------------------------------------------------------------------------------------- //

        function addTreatment(treatment) {

            var isInArray = checkDuplicity(vm.treatmentsContact, treatment);            
            var message = '';

            if (isInArray) {
                message = '<p style="font-size: 14px;">Ya agregaste ' + treatment + ' a tu consulta</p>';
                showToastr('warning', message);
            }
            else {
                vm.treatmentsContact.push(treatment);
                message = '<p style="font-size: 14px;"><strong>' + treatment + '</strong> se agregó a tu consulta!</p>';
                showToastr('success', message);
            }

        }


        /**
         * Checks if value exists in current array
         * @param {string[]} array
         * @param {any} item
         * @returns {boolean} If value exists in array
         */
        function checkDuplicity(array, item) {
            var result = array.indexOf(item);

            return result != -1 ? true : false;

        }

        /**
         * 
         * @param {string} toastrType
         * @param {string} treatment
         */
        function showToastr(toastrType, message) {
            toastr[toastrType](message);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('innovasalud')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log, Analytics) {        
        $log.log('Developed by PROSMART.XYZ');
    }

})();

(function () {
    'use strict';

    angular
        .module('innovasalud')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($locationProvider, $stateProvider, $urlRouterProvider) {
        $locationProvider.hashPrefix('');

        $stateProvider
            .state('home', {
                url: '/',
                templateUrl: 'app/main/main.html',
                controller: 'MainController',
                controllerAs: 'main'
            })
            .state('botox', {
                url: '/botox',
                templateUrl: 'app/main/main.html',
                controller: 'MainController',
                controllerAs: 'main'
            });

        $urlRouterProvider.otherwise('/');
    }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('innovasalud')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function () {
    'use strict';

    angular
        .module('innovasalud')
        .config(config);

    /** @ngInject */
    function config($logProvider, AnalyticsProvider, toastrConfig) {
        AnalyticsProvider.setAccount('UA-20616727-1');


        // Enable log
        $logProvider.debugEnabled(true);

        // Set options third-party lib
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.containerId = 'toast-container';
        toastrConfig.positionClass = 'toast-top-right';
        toastrConfig.preventDuplicates = false;
        toastrConfig.progressBar = true;
    }

})();
angular.module("innovasalud").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<innova-navbar treatments-count=\"main.treatmentsContact.length\"></innova-navbar><section class=\"section-white\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"section-headers\"><h1 style=\"color: #601c5f;\">Bienvenidos</h1><p class=\"lead\">Nuestros nuevos tratamientos, con la mejor tecnología y a la vanguardia de la medicina estética para ti en Viña del Mar. Puedes contactarnos para saber más sobre algún tratamiento, no dudes en hacernos llegar todas tus consultas.</p><hr class=\"purple\"></div></div></div><tratamientos on-treatment-add=\"main.addTreatment($event.treatment)\"></tratamientos></div></section><section class=\"section-color\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"section-headers\"><h2>Tratamientos Clásicos</h2><p>Nuestros tratamientos de siempre siguen disponibles para ti, agenda tu visita o escríbenos para mayores consultas</p><hr class=\"white\"></div></div></div><tratamientos-clasicos on-treatment-add=\"main.addTreatment($event.treatment)\"></tratamientos-clasicos></div></section><section class=\"section-white\" id=\"equipo-component\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"section-headers\"><h1 style=\"color: #601c5f;\">Equipo Médico</h1><p class=\"lead\">Nuestro equipo médico está formado por profesionales de la salud comprometidos con entregar el mejor y más completo servicio</p><hr class=\"purple\"></div></div></div><equipo-medico></equipo-medico></div></section><section class=\"section-color section-separator\" id=\"separator-1\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><h1 class=\"text-center\"><i class=\"fa fa-camera\" aria-hidden=\"true\"></i></h1><h1 class=\"text-center hidden-sm hidden-xs\">Tecnología de vanguardia, cómodas instalaciones y el mejor servicio</h1></div></div></div></section><section class=\"section-white\" id=\"equipo-component\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-6 col-sm-12\"><img class=\"img-responsive\" src=\"assets/images/neostrata.jpg\"></div><div class=\"col-lg-6\"><div class=\"section-headers\" style=\"margin-top: 100px;\"><h3 style=\"color: #601c5f;\">Distribuidores Neostrata</h3><p class=\"lead\">Ven a conocer los productos <strong>Neostrata</strong>. Todos los productos están testeados científicamente y con resultados demostrados</p></div></div></div></div></section><section class=\"section-color\" id=\"testimonios-component\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"section-headers\"><h2>Testimonios</h2><hr class=\"white\"></div></div></div><testimonios></testimonios></div></section><section class=\"section-white\" id=\"contacto-component\" style=\"margin-bottom: 100px;\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"section-headers\"><h1 style=\"color: #601c5f;\">Contacto</h1><p class=\"lead\">Envíanos tus dudas respecto a nuestros tratamientos, horas de consulta o cualquier información adicional que necesites</p><hr class=\"purple\"></div></div></div><contacto treatments=\"main.treatmentsContact\" on-treatment-remove=\"main.treatmentsContact.splice($item.index, 1)\"></contacto></div></section><inbox-helper treatments=\"main.treatmentsContact\"></inbox-helper><script>\r\n\r\n  (function () {\r\n\r\n    var vegasSelector = \'#separator-1\';\r\n\r\n    var vegasSettings = {\r\n      slides: slidesGenerator(\'assets/images/header/\', \'innovasalud\', \'jpg\', 0, 19),\r\n      overlay: \'assets/images/patterns/washi-dark.png\',\r\n      animation: \'random\'\r\n    }\r\n\r\n    $(vegasSelector).vegas(vegasSettings);\r\n\r\n\r\n    function slidesGenerator(route, prefix, extension, from, to) {\r\n      var slides = [];\r\n\r\n      for (var i = from; i <= to; i++) {\r\n        var obj = { src: route + prefix + \'-\' + i + \'.\' + extension };\r\n        slides.push(obj);\r\n\r\n      }\r\n\r\n      return slides;\r\n    }\r\n\r\n\r\n  })();\r\n\r\n</script>");
$templateCache.put("app/messages/messages.html","<p class=\"ngMessageAnimation text-danger\" ng-message=\"required\"><small>Este campo es <strong>requerido</strong></small></p><p class=\"ngMessageAnimation text-danger\" ng-message=\"minlength\"><small>El campo es <strong>demasiado corto</strong></small></p><p class=\"ngMessageAnimation text-danger\" ng-message=\"maxlength\"><small>El campos es <strong>demasiado largo</strong></small></p><p class=\"ngMessageAnimation text-danger\" ng-message=\"email\"><small>El campo debe ser <strong>un correo v&aacute;lido</strong></small></p><p class=\"ngMessageAnimation text-danger\" ng-message=\"passwordMatch\"><small>Las contrase&ntilde;as <strong>no coinciden</strong></small></p><p class=\"ngMessageAnimation text-danger\" ng-message=\"validRut\"><small><strong>El RUT no es valido</strong></small></p><p class=\"ngMessageAnimation text-danger\" ng-message=\"validCharacters\"><small><strong>Caracter no valido (punto)</strong></small></p><p class=\"ngMessageAnimation text-danger\" ng-message=\"noDots\"><small><strong>Tiene puntos</strong></small></p><p class=\"ngMessageAnimation text-danger\" ng-message=\"invalidPassword\"><small>El password no es <strong>v&aacute;lido</strong></small></p>");
$templateCache.put("app/components/clasicos/clasicos.seo.html","<div class=\"row\"><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box-dark\" id=\"maximus-trilipo-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Maximus Trilipo\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><h4>Maximus Trilipo</h4><p>Estimula directamente la musculatura, reduce la grasa corporal y la flaccidez con un método no invasivo</p><ul><li><strong>Reduce</strong> el edema y el volumen graso</li><li><strong>Elimina</strong> desechos mediante drenaje sin succión</li><li><strong>Reafirma</strong> el exceso de piel que va quedando al reducir el volúmen graso</li></ul></div></div><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box-dark\" id=\"acido-hialuronico-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Ácido Hialurónico\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><h4>Ácido Hialurónico</h4><p>Rejuvenecimiento con resultados <strong>inmediatos y sin cirugías.</strong></p><p>El <strong>Ácido Hialurónico</strong> está indicado para remodelar formas y contornos del rostro y labios, otorgar volumen en zonas alteradas por el proceso de envejecimiento o simplemente para rellenar surcos y arrugas</p></div></div><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box-dark\" id=\"depilacion-laser-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Depilación Láser\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><h4>Depilación Láser</h4><p>ACTIVE trabaja la energía lumínica de una forma diferente, garantizando no sólo buenos resultados, sino también la ausencia de riesgos de quemaduras.</p><p>Depilación vello hormonal y en piel sensible. Depilación progresiva en 6 ssesiones</p></div></div></div><div class=\"row\"><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box-dark\" id=\"kinesiologia-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Kinesiología\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><h4>Kinesiología</h4><p>Los tratamientos ofrecidos por nuestros kinesiólogos son:</p><ul><li>Deportiva & Traumatológica</li><li>Post-Operatoria</li><li>Adulto Mayor</li><li>Tratamiento dolor crónico</li><li>Drenaje Linfático Manual</li></ul></div></div><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box-dark\" id=\"nutricion-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Nutrición\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><h4>Nutrición</h4><p>De vital apoyo para el tratamiento y diagnóstico de todo tipo de patologías nutricionales, adaptados al perfil de cada paciente</p><ul><li>Sobrepeso</li><li>Obesidad</li><li>Diabetes</li><li>Trastornos Alimenticios</li></ul></div></div><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box-dark\" id=\"terapias-alternativas-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Terapias Alternativas\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><h4>Terapias Alternativas</h4><p>Dirigido para quienes deseen mejorar su postura corporal, evitar dolores musculares, reducir niveles de estrés, bajar o equilibrar su peso y reducir la ansiedad. También útil para personas con tensiones musculares y deportistas con fatigas o contracturas</p><ul><li>Medicina China</li><li>Shiatsu</li><li>Oki-Do</li><li>Masaje Tailandés</li><li>Onnetsu</li></ul></div></div></div>");
$templateCache.put("app/components/consultaseparador/consultaseparador.seo.html","");
$templateCache.put("app/components/contacto/contacto.seo.html","<div id=\"contacto\" class=\"row\"><div class=\"col-lg-6 col-lg-offset-3 col-sm-12\"><form role=\"form\" name=\"contactForm\" ng-submit=\"$ctrl.submit()\" novalidate=\"\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': contactForm.name.$touched && contactForm.name.$invalid, \'has-success\': contactForm.name.$valid }\"><label for=\"name\" class=\"control-label\">Nombre</label> <input type=\"text\" class=\"form-control\" name=\"name\" id=\"name\" ng-model=\"$ctrl.message.name\" required=\"\"> <span class=\"glyphicon form-control-feedback\" ng-class=\"{\'glyphicon-ok\': contactForm.name.$valid, \'glyphicon-remove\': contactForm.name.$touched && contactForm.name.$invalid }\" aria-hidden=\"true\"></span><div ng-messages=\"contactForm.name.$error\" ng-show=\"contactForm.name.$touched\" class=\"ngMessagesAnimation\" ng-messages-multiple=\"\"><div ng-messages-include=\"app/messages/messages.html\"></div></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': contactForm.email.$touched && contactForm.email.$invalid, \'has-success\': contactForm.email.$valid }\"><label for=\"email\" class=\"control-label\">Correo Electrónico</label> <input type=\"email\" class=\"form-control\" name=\"email\" id=\"email\" ng-model=\"$ctrl.message.email\" required=\"\"> <span class=\"glyphicon form-control-feedback\" ng-class=\"{\'glyphicon-ok\': contactForm.email.$valid, \'glyphicon-remove\': contactForm.email.$touched && contactForm.email.$invalid }\" aria-hidden=\"true\"></span><div ng-messages=\"contactForm.email.$error\" ng-show=\"contactForm.email.$touched\" class=\"ngMessagesAnimation\" ng-messages-multiple=\"\"><div ng-messages-include=\"app/messages/messages.html\"></div></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': contactForm.phone.$touched && contactForm.phone.$invalid, \'has-success\': contactForm.phone.$valid }\"><label for=\"phone\" class=\"control-label\">Teléfono</label> <input type=\"text\" class=\"form-control\" name=\"phone\" id=\"phone\" ng-model=\"$ctrl.message.phone\" required=\"\"> <span class=\"glyphicon form-control-feedback\" ng-class=\"{\'glyphicon-ok\': contactForm.phone.$valid, \'glyphicon-remove\': contactForm.phone.$touched && contactForm.phone.$invalid }\" aria-hidden=\"true\"></span><div ng-messages=\"contactForm.phone.$error\" ng-show=\"contactForm.phone.$touched\" class=\"ngMessagesAnimation\" ng-messages-multiple=\"\"><div ng-messages-include=\"app/messages/messages.html\"></div></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': contactForm.message.$touched && contactForm.message.$invalid, \'has-success\': contactForm.message.$valid }\"><label for=\"message\" class=\"control-label\">Mensaje</label> <textarea rows=\"8\" class=\"form-control\" name=\"message\" id=\"message\" ng-model=\"$ctrl.message.message\" placeholder=\"Quisiera recibir información respecto a los tratamientos que seleccioné. Muchísimas gracias!\"></textarea><div ng-messages=\"contactForm.message.$error\" ng-show=\"contactForm.message.$touched\" class=\"ngMessagesAnimation\" ng-messages-multiple=\"\"><div ng-messages-include=\"app/messages/messages.html\"></div></div></div><div class=\"row\" style=\"margin-bottom: 30px;\" ng-show=\"$ctrl.treatments.length > 0\"><div class=\"col-lg-12 col-sm-12 text-center\"><h6>Tratamientos seleccionados:</h6><a href=\"\" ng-click=\"$ctrl.removeTreatment($index)\"><span ng-repeat=\"item in $ctrl.treatments track by $index\" class=\"label label-primary\" style=\"margin-bottom: 10px; margin-right:10px;\">{{item}} <i class=\"fa fa-times\" aria-hidden=\"true\"></i></span></a></div></div><button class=\"btn btn-block btn-default\" type=\"submit\" ng-disabled=\"!contactForm.$valid\" ng-class=\"{\'btn-success\': contactForm.$valid}\">ENVIAR CONSULTA <i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></button></form></div></div>");
$templateCache.put("app/components/equipo/equipo.seo.html","<div id=\"equipo-medico\"><div class=\"row team-member\"><div class=\"col-lg-4 col-xs-12\"><img class=\"img-placeholder img-responsive img-circle center-block\" src=\"assets/images/pamela-tapia-innovasalud.jpg\"></div><div class=\"col-lg-8 col-sm-12 team-member\"><h2 class=\"hero-title\">Dra. Pamela Tapia Vera-Cruz</h2><p class=\"text-uppercase lead\"><strong>Medicina Estética y Director Médico Innova Salud</strong></p><p class=\"text-uppercase lead\">Médico Cirujano - <em>Universidad de Chile</em></p><p class=\"text-uppercase\"><strong>Medicina Preventiva y Salud Ocupacional</strong></p></div></div><div class=\"row\"><div class=\"col-lg-4 col-xs-6 team-member\"><div class=\"row\"><div class=\"col-lg-4\"><img class=\"img-placeholder img-responsive img-circle center-block\" src=\"assets/images/edith-oliveros-innovasalud.jpg\"></div><div class=\"col-lg-8\"><h4>Edith Oliveros</h4><p>Paramédico</p></div></div></div><div class=\"col-lg-4 col-xs-6 team-member\"><div class=\"row\"><div class=\"col-lg-4\"><img class=\"img-placeholder img-responsive img-circle center-block\" src=\"assets/images/andrea-martinez-innovasalud.jpg\"></div><div class=\"col-lg-8\"><h4>Andrea Martínez</h4><p>Kinesióloga</p><p><small>Universidad de Antofagasta</small></p><p><small>Universidad Rey Juan Cuarlos, Madrid</small></p></div></div></div><div class=\"col-lg-4 col-xs-6 col-lg-offset-0 team-member\"><div class=\"row\"><div class=\"col-lg-4\"><img class=\"img-placeholder img-responsive img-circle center-block\" src=\"assets/images/isabel-tocornal-innovasalud.jpg\"></div><div class=\"col-lg-8\"><h4>Isabel Tocornal</h4><p>Kinesióloga</p><p><small>Universidad Mayor</small></p></div></div></div><div class=\"col-lg-4 col-xs-6 col-lg-offset-4 team-member\"><div class=\"row\"><div class=\"col-lg-4\"><img class=\"img-placeholder img-responsive img-circle center-block\" src=\"assets/images/laura-espeche-innovasalud.jpg\"></div><div class=\"col-lg-8\"><h4>Laura Espeche</h4><p>Terapias Alternativas</p><p>Medicina China</p></div></div></div></div></div>");
$templateCache.put("app/components/footer/footer.component.html","<footer id=\"footer\"><div class=\"container\" style=\"display: block; z-index: 15;\"><div class=\"col-lg-6 col-sm-12\"><address><strong>Innova Salud Centro Médico Integral</strong><br>7 Norte 645 Oficina 1003<br>Edificio Centro Libertad<br>Viña del Mar<br><a style=\"margin-top: 8px;\" class=\"btn btn-xs btn-primary\" target=\"_blank\" href=\"https://www.google.cl/maps/place/INNOVA+SALUD+Centro+M%C3%A9dico+Integral/@-33.0161304,-71.5531926,17z/data=!3m1!4b1!4m5!3m4!1s0x9689dde7065d5eb9:0xcdc366a2ad7c87b9!8m2!3d-33.0161304!4d-71.5510039\">VER EN GOOGLE MAPS <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i></a><br><br><strong>Fijo:</strong> <a href=\"tel:+56323190658\">(32) 3190658</a><br><strong>Móvil:</strong> <a href=\"tel:+56975597445\">+56 9 7549 7445</a><br></address></div></div></footer>");
$templateCache.put("app/components/inbox/inbox.component.html","<a href=\"\" scroll-to=\"contacto-component\" offset=\"75\"><div id=\"inbox-button\" data-badge=\"{{$ctrl.treatments.length}}\" uib-tooltip=\"{{$ctrl.tooltipText}}\" tooltip-placement=\"left\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i></div></a>");
$templateCache.put("app/components/navbar/navbar.component.html","<nav class=\"navbar yamm navbar-fixed-top navbar-default\" id=\"innova-navbar\" role=\"navigation\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" ng-init=\"navCollapsed = true\" ng-click=\"navCollapsed = !navCollapsed\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button><a ui-sref=\"home\"><img id=\"innova-brand\" width=\"250\" src=\"assets/images/logos/innova-salud@2x.png\"></a></div><div id=\"navbar\" class=\"navbar-collapse collapse navbar-right\" uib-collapse=\"navCollapsed\"><ul class=\"nav navbar-nav\"><li class=\"dropdown yamm-fw\" uib-dropdown=\"\" auto-close=\"outsideClick\"><a class=\"dropdown-toggle\" uib-dropdown-toggle=\"\" href=\"\">TRATAMIENTOS <b class=\"caret\"></b></a><ul class=\"dropdown-menu\" role=\"menu\"><li><navbar-tratamientos></navbar-tratamientos></li></ul></li><li><a href=\"\" scroll-to=\"equipo-component\" offset=\"75\">NUESTRO EQUIPO</a></li><li><a href=\"\" scroll-to=\"testimonios-component\" offset=\"75\">TESTIMONIOS</a></li><li><a href=\"\" scroll-to=\"contacto-component\" offset=\"75\">CONTACTO <span ng-show=\"$ctrl.treatmentsCount > 0\" class=\"badge\">{{$ctrl.treatmentsCount}}</span></a></li></ul></div></div></nav>");
$templateCache.put("app/components/navbar/navbar.tratamientos.html","<div class=\"yamm-content\"><div class=\"row\"><div class=\"col-lg-8 col-sm-12\"><div class=\"row\"><div class=\"col-lg-6 col-sm-12\"><a href=\"\" scroll-to=\"hifu-box\" offset=\"80\" class=\"treatment-link\"><div class=\"innova-box-nav\"><h5>ULTRAFORMER III</h5><p class=\"text-uppercase\">ULTRA SONIDO FOCALIZADO</p></div></a></div><div class=\"col-lg-6 col-sm-12\"><a href=\"\" scroll-to=\"dieta-proteinada-box\" offset=\"80\" class=\"treatment-link\"><div class=\"innova-box-nav\"><h4>Método SUICO®</h4><p class=\"text-uppercase\">Dieta proteinada para la pérdida de peso</p></div></a></div><div class=\"col-lg-6 col-sm-12\"><a href=\"\" scroll-to=\"hilos-tensores-box\" offset=\"80\" class=\"treatment-link\"><div class=\"innova-box-nav\"><h5>Hilos Tensores</h5><p class=\"text-uppercase\">HILOS REABSORBIBLES PDO</p></div></a></div><div class=\"col-lg-6 col-sm-12\"><a href=\"\" scroll-to=\"electroporacion-box\" offset=\"80\" class=\"treatment-link\"><div class=\"innova-box-nav\"><h5>Electroporación</h5><p class=\"text-uppercase\">MESOTERAPIA <strong>SIN AGUJAS</strong></p></div></a></div><div class=\"col-lg-6 col-sm-12\"><a href=\"\" scroll-to=\"carboxiterapia-box\" offset=\"80\" class=\"treatment-link\"><div class=\"innova-box-nav\"><h5>Carboxiterapia</h5><p class=\"text-uppercase\">CO2 SUBCUTÁNEO <strong>DERMOTHERAP</strong></p></div></a></div><div class=\"col-lg-6 col-sm-12\"><a href=\"\" scroll-to=\"mesoterapia-box\" offset=\"80\" class=\"treatment-link\"><div class=\"innova-box-nav\"><h5>Mesoterapia</h5><p class=\"text-uppercase\">FACIAL & CORPORAL</p></div></a></div><div class=\"col-lg-6 col-sm-12\"><a href=\"\" scroll-to=\"vitamina-c-box\" offset=\"80\" class=\"treatment-link\"><div class=\"innova-box-nav\"><h5>Vitamina C</h5><p class=\"text-uppercase\">TERAPIA ENDOVENOSA</p></div></a></div><div class=\"col-lg-6 col-sm-12\"><a href=\"\" scroll-to=\"hydrafacial-box\" offset=\"80\" class=\"treatment-link\"><div class=\"innova-box-nav\"><h5>Hydrafacial MD™</h5><p class=\"text-uppercase\">SALUD DE LA PIEL</p></div></a></div></div></div><div class=\"col-lg-4 col-sm-12\"><h4 style=\"color: #601c5f;\">Tratamientos Clásicos</h4><hr><ul><li><a href=\"\" scroll-to=\"maximus-trilipo-box\" offset=\"80\">Maximus TriLipo</a></li><li><a href=\"\" scroll-to=\"acido-hialuronico-box\" offset=\"80\">Ácido Hialurónico</a></li><li><a href=\"\" scroll-to=\"depilacion-laser-box\" offset=\"80\">Depilación Láser</a></li><li><a href=\"\" scroll-to=\"kinesiologia-box\" offset=\"80\">Kinesiología</a></li><li><a href=\"\" scroll-to=\"nutricion-box\" offset=\"80\">Nutrición</a></li><li><a href=\"\" scroll-to=\"terapias-alternativas-box\" offset=\"80\">Terapias Alternativas</a></li></ul></div></div></div>");
$templateCache.put("app/components/owljumbo/owljumbo.html","<div id=\"jumbo-owl\" class=\"owl-carousel\"><div class=\"owl-item\"><h1>Dieta Proteinada</h1></div><div class=\"owl-item\"><h1>Hilos Tensores</h1></div><div class=\"owl-item\"><h1>Carboxiterapia</h1></div><div class=\"owl-item\"><h1>Electroporacion</h1></div><div class=\"owl-item\"><h1>HiFu</h1></div></div>");
$templateCache.put("app/components/testimonios/testimonios.seo.html","<div class=\"row\"><div class=\"col-lg-12\"><div id=\"owl-testimonios\" class=\"owl-carousel\"><div class=\"owl-item\"><blockquote><p class=\"text-center\">\"Empecé con la <strong>Dieta Proteinada SUICO</strong> a mediados de Septiembre 2016 pesando 78 kgs. Estaba muy afectada por bajar de peso, me sentía mal conmigo misma, con baja autoestima, me pesaba el cuerpo, etc. Llegué a la consulta de la Dra. Pamela Tapia quien me explicó en qué consistía la dieta y las fases por las que iba a pasar, me explicó que la dieta esta basada en proteínas y que me sentiría mucho mejor al terminar el tratamiento. Y así fue. Hoy me encuentro en la fase 4 pesando 64.9 kgs. Mi vida cambió por completo: hago deporte, troto por la playa e incluso participé en el cross country de mi colegio.\"</p></blockquote><div class=\"testimonial-user\"><img src=\"assets/images/testimonios/josefina-delaveau-innovasalud.jpg\" class=\"img-circle center-block\"><h4 class=\"text-center\">Josefina Delaveau</h4><p class=\"text-center\"><em>17 años, Viña del Mar</em></p></div></div><div class=\"owl-item\"><blockquote><p class=\"text-center\" style=\"padding-top: 20px;\">\"<strong>Hydrafacial MD</strong> fue la solución a mi piel. Es increíble como en <strong>menos de una hora</strong> tu piel cambia radicalmente luciendo radiante, limpia e hidratada. <strong>Lo recomiendo 100%.</strong> Además, si la utilizas habitualmente, el cambio de tu piel es realmente sorprendente.\"</p></blockquote><div class=\"testimonial-user\"><img src=\"assets/images/testimonios/andrea-abascal-innovasalud.jpg\" class=\"img-circle center-block\"><h4 class=\"text-center\">Andrea Abascal</h4><p class=\"text-center\"><em>29 años, Viña del Mar</em></p></div></div><div class=\"owl-item\"><blockquote><p class=\"text-center\" style=\"padding-top: 20px;\">\"Destaco la atención responsable y personalizada del equipo, además de que el lugar es muy acogedor. Uno se siente muy cómoda realizando cualquier tipo de tratamiento estético, ya que utilizan productos y máquinas de muy buena calidad con sus respectivas certificaciones, lo que garantiza y asegura los resultados.\"</p></blockquote><div class=\"testimonial-user\"><img src=\"assets/images/testimonios/paulina-meyer-innovasalud.jpg\" class=\"img-circle center-block\"><h4 class=\"text-center\">Paulina Meyer</h4><p class=\"text-center\"><em>33 años, Viña del Mar</em></p></div></div></div></div></div>");
$templateCache.put("app/components/tratamientos/tratamientos.seo.html","<div class=\"row\"><div class=\"col-lg-8 hidden-xs hidden-sm\"><div class=\"innova-box-double\" style=\"background-image: url(assets/images/tratamientos/ultraformer-III-big-v2.jpg)\" id=\"hifu-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Ultraformer III\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><div class=\"ribbon-corner\"><span>DESTACADO</span></div><p class=\"small text-uppercase\">Ultra Sonido Focalizado de Alta Intesidad</p><h3>Ultraformer III</h3><div class=\"innova-box-content\"><p><strong>Máxima eficacia para lifting facial, reducción de arrugas y <em>contouring</em> corporal con ULTRAFORMER III</strong>. Fortaleza, rapidez, menos dolor y versatilidad. Las regiones sensibles alrededor de los ojos, la boca y la frente se tratan con facilidad gracias a sus diferentes boquillas</p></div></div></div><div class=\"col-sm-12 hidden-md hidden-lg\"><div class=\"innova-box\" style=\"background-image: url(assets/images/tratamientos/hifu.jpg)\" id=\"hifu-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Ultraformer III\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><div class=\"ribbon-corner\"><span>DESTACADO</span></div><p class=\"small text-uppercase\">Ultra Sonido Focalizado de Alta Intesidad</p><h3>Ultraformer III</h3><div class=\"innova-box-content\"><p>Máxima eficacia para lifting facial, reducción de arrugas y <em>contouring</em> corporal con ULTRAFORMER III. Fortaleza, rapidez, menos dolor y versatilidad. Las regiones sensibles alrededor de los ojos, la boca y la frente se tratan con facilidad debido a la precisión de sus boquillas</p></div></div></div><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box\" style=\"background-image: url(assets/images/tratamientos/dieta-proteinada.jpg)\" id=\"dieta-proteinada-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Dieta Proteinada\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><div class=\"ribbon-corner\"><span>NUEVO</span></div><p class=\"small text-uppercase\">DIETA PROTEINADA PARA LA P&Eacute;RDIDA DE PESO</p><h3>M&eacute;todo <strong>SUICO®</strong></h3><div class=\"innova-box-content\"><p><strong>Tratamiento m&eacute;dico</strong> de reducción rápida de peso, basado en estudios científicos rigurosos y cuya aplicación está sujeta a un programa preciso.</p><p>Pérdida de exceso de peso, educación alimentaria y mantenimiento del peso logrado son los tres pilares de esta novedosa técnica médica</p></div></div></div><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box\" style=\"background-image: url(assets/images/tratamientos/hilos-tensores-pdo.jpg)\" id=\"hilos-tensores-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Hilos Tensores\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><div class=\"ribbon-corner\"><span>NUEVO</span></div><p class=\"small text-uppercase\">HILOS REABSORBIBLES PDO</p><h3>Hilos Tensores</h3><div class=\"innova-box-content\"><p><strong>Efecto lifting sin cirugía</strong> mediante el uso de hilos de <strong>polidioxanona</strong> que estimulan la producción natural de colágeno para tratar la <strong>flacidez corporal</strong> en muslos, brazos, glúteos y zona facial. Sus efectos duran entre 1 y 2 a&ntilde;os en un procedimiento que toma entre 30 y 60 minutos, son invisbles y reabsorbibles.</p></div></div></div><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box\" style=\"background-image: url(assets/images/tratamientos/electroporacion.jpg)\" id=\"electroporacion-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Electroporación\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><div class=\"ribbon-corner\"><span>NUEVO</span></div><p class=\"small text-uppercase\">MESOTERAPIA <strong>SIN AGUJAS</strong></p><h3>Electroporaci&oacute;n</h3><div class=\"innova-box-content\"><p>Introducción de activos <strong>sin inyecciones</strong> mediante la permeablización de las células a través de pulsos eléctricos. Rejuvenecimiento, tratamientos antiacnéicos, cicatrices (queloides), despigmentantes, tonicidad, etc. todo mediante la introducción de activos como Carnitina, vitaminas, minerales y muchos más sin el uso de agujas</p></div></div></div><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box\" style=\"background-image: url(assets/images/tratamientos/carboxiterapia.jpg)\" id=\"carboxiterapia-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Carboxiterapia CO2\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><div class=\"ribbon-corner\"><span>NUEVO</span></div><p class=\"small text-uppercase\">CO2 SUBCUT&Aacute;NEO <strong>DERMOTHERAP</strong></p><h3>Carboxiterapia</h3><div class=\"innova-box-content\"><p>Método mínimamente invasivo para tratar <strong>celulitis, flacidez y grasa localizada</strong> mediante la aplicación de gas <strong>dióxido de carbono</strong>. Reestablece la microcirculación aumentando así el flujo sanguíneo a las zonas tratadas.</p></div></div></div><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box\" style=\"background-image: url(assets/images/tratamientos/mesoterapia-facial.jpg)\" id=\"mesoterapia-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Mesoterapia Facial\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><div class=\"ribbon-corner\"><span>NUEVO</span></div><p class=\"small text-uppercase\">FACIAL & CORPORAL</p><h3>Mesoterapia</h3><div class=\"innova-box-content\"><p>Técnica de tratamiento en medicina estética que devuelve a la piel luminosidad, hidratación y tersura. Consiste en microinfiltraciones <strong>intradérmicas e indoloras</strong> de medicamentos y nutrientes en puntos estratégicos del rostro, cuello, escote y cuerpo. La mesoterapia corporal es altamente eficaz para reducir la <strong>grasa localizada y la celulitis</strong></p></div></div></div><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box\" style=\"background-image: url(assets/images/tratamientos/vitamina-c.jpg)\" id=\"vitamina-c-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Vitamina C\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><div class=\"ribbon-corner\"><span>NUEVO</span></div><p class=\"small text-uppercase\">TERAPIA ENDOVENOSA CON</p><h3>Vitamina C</h3><div class=\"innova-box-content\"><p>Mejora la calidad de la piel, aumenta la energía corporal, protege contra el envejecimiento de nuestras células, aumenta la respuesta inmunitaria, regula presión arterial alta, entre muchos otros beneficios. Utilizada por su potente acción antioxidante, promueve la formación de colágeno ayudando a mejorar la luminosidad, el tono y textura de la piel</p><p></p></div></div></div><div class=\"col-lg-4 col-sm-12\"><div class=\"innova-box\" style=\"background-image: url(assets/images/tratamientos/hydrafacial.jpg)\" id=\"hydrafacial-box\"><a href=\"\" ng-click=\"$ctrl.addTreatment(\'Hydrafacial MD\')\"><div class=\"ribbon-horizontal\"><div class=\"ribbon-content\"><h1><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> CONSULTA AQUÍ POR...</h1></div></div></a><div class=\"ribbon-corner\"><span>NUEVO</span></div><p class=\"small text-uppercase\">SALUD DE LA PIEL</p><h3>Hydrafacial MD™</h3><div class=\"innova-box-content\"><p>Ven a conocer el nuevo y revolucionario tratamiento para desintoxicar, rejuvenecer y proteger la salud de tu piel. Limpieza, exfoliación, extracción de impurezas y protección para todos los tipos de piel con resultados inmediatos. Con <strong>HydraFacial™</strong> tendrás una piel limpia, con clara reducción de poros e hidratada.</p><p></p></div></div></div></div>");
$templateCache.put("app/components/vegas-header/vegas-header.component.html","<section id=\"vegas-header\"></section><script>\r\n\r\n  (function () {\r\n\r\n    var vegasSelector = \'#vegas-header\';\r\n\r\n    var vegasSettings = {\r\n      slides: [\r\n        { src: \'assets/images/header/vegas-1.jpg\' },\r\n        { src: \'assets/images/header/vegas-2.jpg\' }\r\n      ],\r\n      overlay: \'assets/images/patterns/washi-dark.png\',\r\n      animation: \'random\'\r\n    }\r\n\r\n    $(vegasSelector).vegas(vegasSettings);\r\n\r\n  })();\r\n\r\n</script>");}]);